



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class logoutModal extends Vue {
    title = "ログアウトしますか？";
    message = "「ラベル屋さんクラウド」からログアウトしますか？";

    clickLogoutButton(){
        this.$emit('close');
        this.$emit('logout');
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
